<template>
	<v-card>
		<v-card-title></v-card-title>
		<v-card-text>
			<v-progress-linear
				v-if="isLoadingAccountManagers"
				indeterminate
				color="primary"
			></v-progress-linear>
			<v-treeview
				v-else
				v-model="computedAccountManagersIds"
				:items="accountManagers"
				:load-children="getAccountManagers"
				multiple-active
				selected-color="primary"
				selectable
				open-all
				dense
			>
			</v-treeview>
		</v-card-text>
		<v-card-actions>
			<v-spacer></v-spacer>
			<v-btn
				@click="$emit('close')"
				color="tertiary"
				class="black--text"
			>
				Annulla
			</v-btn>
			<v-btn
				color="secondary"
				@click="$emit('apply')"
			>
				Applica
			</v-btn>
		</v-card-actions>
	</v-card>
</template>

<script>
import {mapGetters, mapMutations} from "vuex";

export default {
	data() {
		return {
			accountManagers: [
				{
					id: 'tutti',
					name: 'Tutti',
					children: [],
				},
			],
			isLoadingAccountManagers: false,
		}
	},
	
	computed: {
		...mapGetters({
			accountManagersIds: 'sharedFilters/accountManagersIds'
		}),
		computedAccountManagersIds: {
			get: function () {
				return this.accountManagersIds.value;
			},
			set: function (value) {
				// if (value?.length === 0) value = null;
				this.setAccountManagersIdsNotApplied(value);
			}
		}
	},
	
	created() {
		this.getAccountManagers();
	},
	
	methods: {
		...mapMutations({
			setAccountManagersIdsNotApplied: 'sharedFilters/SET_ACCOUNT_MANAGERS_IDS_NOT_APPLIED',
		}),
		getAccountManagers() {
			this.isLoadingAccountManagers = true;
			axios.get('/api/account-managers')
				.then(response => {
					let accountManagersByGroup = Object.groupBy(response.data, ({ gruppo }) => gruppo);
					
					let accountManagersTree = [];
					for (const key in accountManagersByGroup) {
						accountManagersTree.push({
							id: key,
							name: key,
							children: accountManagersByGroup[key].map(am => ({
								id: am.id,
								name: am.nome_cognome
							}))
						})
					}
					
					this.accountManagers[0].children = accountManagersTree;
				})
				.finally(() => {
					this.isLoadingAccountManagers = false;
				})
		},
	}
}
</script>